module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Bold.21cb2ec3.woff";